export default __webpack_public_path__ + "static/media/business.1f17aba8.svg";